
import { useStore } from "vuex";
import { nounsMapConfig } from "@/config/project";
import { User } from "firebase/auth";
import {
  defineComponent,
  ref,
  computed,
  WritableComputedRef,
  watch,
} from "vue";
import { PhotoPubData } from "@/models/photo";
import { uploadFile } from "@/utils/storage";
import heic2any from "heic2any";
import { db } from "@/utils/firebase";
import { doc, updateDoc, getDoc, serverTimestamp } from "firebase/firestore";
import { photoNFTPosted } from "@/utils/functions";

export default defineComponent({
  emits: {},
  setup() {
    const user = computed<User>(() => store.state.user);
    const isShow = ref<boolean>(false);
    const errorAlready = ref<boolean>(false);
    const fileInput = ref();
    const fileError = ref<boolean>(false);
    const previewImage = ref();
    const nameRef = ref();
    const nameError = ref<boolean>(false);
    const descRef = ref();
    const descError = ref<boolean>(false);
    const store = useStore();
    const processing = ref<boolean>(false);
    const nftRequestPhoto: WritableComputedRef<PhotoPubData | null> = computed({
      get: () => store.state.nftRequestPhoto as PhotoPubData,
      set: (val) => store.commit("setNftRequestPhoto", val),
    });
    const pickFile = async () => {
      const files = fileInput.value.files;
      console.log("picked", files);
      if (files && files[0]) {
        if (/\.(jpe?g|png|gif)$/i.test(files[0].name)) {
          const reader = new FileReader();
          reader.onload = async (e) => {
            previewImage.value = e?.target?.result;
          };
          reader.readAsDataURL(files[0]);
        } else if (/\.(heic)$/i.test(files[0].name)) {
          const blob = await heic2any({
            blob: files[0],
            toType: "image/jpeg",
            quality: 0.94,
          });
          previewImage.value = URL.createObjectURL(blob as Blob);
        } else {
          fileInput.value.value = "";
          previewImage.value = "";
        }
      }
    };

    const close = () => {
      nftRequestPhoto.value = null;
    };
    watch(nftRequestPhoto, async () => {
      console.log(nftRequestPhoto.value);
      if (nftRequestPhoto.value) {
        //check request is from user(owner) or not.
        const photoId = nftRequestPhoto.value.photoId;
        const photoDoc = await getDoc(
          doc(db, `users/${user.value.uid}/public_photos/${photoId}`)
        );
        if (photoDoc.exists()) {
          console.log(photoDoc.data());
          //default icon size is 80, 30
          const rphotoDoc = await getDoc(
            doc(db, `nft_request_photos/${photoId}`)
          );
          if (rphotoDoc.exists()) {
            errorAlready.value = true;
          }
          isShow.value = true;
        } else {
          console.log("wrongUser", user.value?.uid);
          close();
        }
      }
    });

    const nftRequest = async () => {
      if (!nftRequestPhoto.value) {
        return;
      }
      const photoId = nftRequestPhoto.value.photoId;
      console.log("request NFT ", photoId);

      //Input確認
      const file = fileInput.value.files[0];
      console.log(file);
      fileError.value = file ? false : true;
      nameError.value = nameRef.value.value ? false : true;
      descError.value = descRef.value.value ? false : true;
      if (fileError.value || descError.value || nameError.value) {
        return;
      }

      //original 画像Upload
      processing.value = true;
      try {
        const storage_path = `images/users/${user.value.uid}/public_photos/${photoId}/nft_original.jpg`;
        const photoURL = (await uploadFile(
          fileInput.value.files[0],
          storage_path,
          "jpeg"
        )) as string;
        console.log({ photoURL });
        //photo meta data 更新
        await updateDoc(
          doc(db, `users/${user.value.uid}/public_photos/${photoId}`),
          {
            original_name: file.name,
            title: nameRef.value.value,
            description: descRef.value.value,
            updatedAt: serverTimestamp(),
          }
        );
        // backend へ nft reqest送信
        const ret = await photoNFTPosted({ photoId });
        console.log(ret);
        processing.value = false;
        close();
      } catch (e: unknown) {
        processing.value = false;
      }
    };
    return {
      isShow,
      errorAlready,
      fileInput,
      fileError,
      previewImage,
      nameRef,
      nameError,
      descRef,
      descError,
      nounsMapConfig,
      nftRequestPhoto,
      processing,
      pickFile,
      close,
      nftRequest,
    };
  },
});
